/*
 * @Author: your name
 * @Date: 2020-08-18 10:16:46
 * @LastEditTime: 2020-08-18 15:43:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-doctor/src/util/filters.js
 */
//全局过滤器模块

//时间显示过滤
export function formatTimeFilter(value) {
	let hours = parseInt(value / 3600)
	hours = hours && hours > 10 ? hours + ':' : hours && hours < 10 ? 0 + hours + ':' : ''
	let min = parseInt(value % 3600 / 60)
	min = min > 9 ? min + ':' : '0' + min + ':'
	let second = parseInt(value % 60)
	second = second > 9 ? second : '0' + second
	return hours + min + second
}
export function showTimeFilter(val){
	return val>9?val:`0${val}`
}